export const weekOverviewPresenceOptions = Object.freeze({
  PRESENT: 'present',
  NOT_PRESENT: 'not_present',
});
